import React from "react";
import t from '../../../helpers/t';
import UserInputItem from "./UserInputItem";

const UserInputItemExtraField = (props) => {
    // console.log(props)
    if(props.value.name  === 'lang') {
        return (
            <>
                <select id="user_item_input_lang" type="text" className="form-control"
                        name="lang" required="" autoComplete="false" placeholder="" value={props.val}
                        onChange={e => props.onChangeForm(e)}>
                    <option value="en_GB">{t('en_GB')}</option>
                    <option value="de_DE">{t('de_DE')}</option>
                    <option value="fr_FR">{t('fr_FR')}</option>
                </select>
            </>
        );
    } else if(props.value.name === 'role') {
        return (
            <>
                <select id="user_item_input_role" type="text" className="form-control"
                        name="role" required="" autoComplete="false" placeholder="" value={props.val}
                        onChange={e => props.onChangeForm(e)}>
                    {props.getAvailableRoles().map((role, index) => {
                        return (
                            <option value={role}>{t('role_' + role)}</option>
                        );
                    })}
                </select>
            </>
        );
    }else if(props.value.name === 'type-recipient') {
        return (
            <>
                <select id="user_item_input_type_recipient" type="text" className="form-control"
                        name="recipient_type" required="" autoComplete="false" placeholder="" value={props.val}
                        disabled={props.disabled}
                        onChange={e => props.onChangeForm(e)}>
                            <option value="">{t('choose type of recipient')}</option>
                    {props.getAvailableTypeRecipient().map((type, index) => {
                        return (
                            <option value={type}>{t(type)}</option>
                        );
                    })}
                </select>
            </>
        );
    }else if(props.value.name === 'type-notification') {
        return (
            <>
                <select id="user_item_input_type_notification" type="text" className="form-control"
                        name="notification_type" required="" autoComplete="false" placeholder="" value={props.val}
                        disabled={props.disabled}
                        onChange={e => props.onChangeForm(e)}>
                            <option value="">{t('choose type of notification')}</option>
                    {props.getAvailableTypeNotification().map((notification, index) => {
                        return (
                            <option value={notification}>{t(notification)}</option>
                        );
                    })}
                </select>
            </>
        );
    } else {
        return (
            <UserInputItem
                value={props.value}
                name={props.name}
                formError={props.formError}
                val={props.val}
                placeholder={props.placeholder}
                onChangeForm={props.onChangeForm}
                getAvailableRoles={props.getAvailableRoles}
            />
        )
    }
};
export default UserInputItemExtraField;